module.exports = __webpack_public_path__ + "static/purpose-intro-d-236205bfbb5ba23a7b966c90d787a425.jpg";